<script setup>
import { ref, computed, watch, nextTick, inject } from 'vue';
import { modelErrorsToHtmlText } from '../../../../libs/cifra/model_errors';

const I18n = inject('I18n');

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  error: { type: [String, Array], default: null },
});

const emit = defineEmits(['update:modelValue']);

const valores = ref([...props.modelValue]);
const valorOrigen = ref(null);
const valorConvertido = ref(null);

const valoresNoEliminados = computed(() => {
  return valores.value.filter((o) => !o._destroy);
});

const eliminarValor = (index) => {
  if (index > -1) {
    const valor = valores.value[index];
    if (valor.id == null) {
      valores.value.splice(valor, 1);
    } else {
      valor._destroy = true;
    }
  }
};

const addValor = () => {
  valores.value.push({});
  nextTick(() => {
    valorOrigen.value[valores.value.length - 1].focus();
  });
};

watch(
  () => valores.value,
  (value) => {
    emit('update:modelValue', value);
  },
  { deep: true },
);
</script>

<template>
  <div class="m-b">
    <table class="table m-b-none">
      <thead>
        <tr>
          <th>
            <abbr title="requerido">*</abbr>
            {{ I18n.t('activerecord.attributes.calificaciones/conversion_valor.valor_origen') }}
          </th>
          <th>
            <abbr title="requerido">*</abbr>
            {{
              I18n.t('activerecord.attributes.calificaciones/conversion_valor.valor_convertido')
            }}
          </th>
          <th class="col-min">
            <button
              type="button"
              class="btn btn-cifra btn-xs"
              @click="addValor"
            >
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(valor, index) in valoresNoEliminados" :key="index">
          <td>
            <input ref="valorOrigen" v-model="valor.valor_origen" class="form-control">
          </td>
          <td>
            <input ref="valorConvertido" v-model="valor.valor_convertido" class="form-control">
          </td>
          <td>
            <i
              class="fa fa-trash text-danger clickable"
              @click="eliminarValor(index)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="error" class="text-danger">
      {{ modelErrorsToHtmlText(error) }}
    </p>
  </div>
</template>

<style scoped>
  table > tbody > tr > td:last-child {
    text-align: center;
  }
  abbr {
    border: 0;
    text-decoration: none;
    color: #fe1d12;
  }
</style>
